<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading"
    v-if="item.heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <Input type="textarea"
      :autosize="{minRows: item.data.minRaws || 2,maxRows: 10}"
      placeholder=""
      v-model="item.data.text" />
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
